import { HTTP } from "./http-common";

export default {
    methods: {
        getRecentData(query, queryValue) {
            if (localStorage.userId == null) { 
                return new Promise((resolve) => {
                    resolve([])
                })
            }
            
            let path = "recent/"
            return new Promise((resolve, reject) => {
                HTTP.get(path, { 
                    params: {
                        'user_id': localStorage.userId,
                        'source': this.source(),
                        'query': query,
                        'queryValue': queryValue
                    }
                  })
                  .then(response => {
                      resolve(response.data['recent'].slice(0,5))
                  })
                  .catch(e => {
                      reject(e)
                  });
            })
        },
        deleteRecentData(manga) {
            if (localStorage.userId == null) { 
                console.log("Don't have user id")
                return new Promise((resolve) => {
                    resolve([])
                })
            }
            let recentId = manga.novel_id.toString() + this.source()
            let path = "recent/"
            return new Promise((resolve, reject) => {
                HTTP.post(path, {
                    'delete': 'delete',
                    'user_id': localStorage.userId,
                    'recent_id': recentId
                })
                .then(response => {
                    resolve(response)
                })
                .catch(e => {
                    reject(e)
                });
            })
        },
        saveRecentData(detail, chapter) {
            if (localStorage.userId == null) { 
                console.log("Don't have user id")
                return
            }

            let recentId = detail.id.toString() + this.source()
            let path = "recent/"
            HTTP.post(path, {
                'chapter_number': chapter.index,
                'chapter_id': chapter.url,
                'novel_id': detail.id,
                'title': detail.title,
                'source': this.source(),
                'thumbnail': detail.thumbnail,
                'recent_id': recentId,
                'user_id': localStorage.userId
            })
            .then(response => {
                console.log(response)
            })
            .catch(e => {
                console.error(e);
            });
        }
    }
}